import { Component, Inject } from "@angular/core";
import { ITransactionGroup } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
export interface AddAdjustmentDialogData
{
    readonly itemId: string;
    readonly transaction: ITransactionGroup;
}
@Component({
    selector: "add-adjustment-dialog-component",
    templateUrl: "./addAdjustmentDialog.tmpl.html",
    standalone: false
})
export class AddAdjustmentDialogComponent
{
    constructor(
        private readonly dialogRef: MatDialogRef<AddAdjustmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: AddAdjustmentDialogData
    ) { }

    get itemId(): string
    {
        return this.data.itemId;
    }

    get transaction(): ITransactionGroup
    {
        return this.data.transaction;
    }
}
